import { logger } from '@curology/logger/client';

const logEligibilityFailure = (err: Error) => {
  logger.log(
    `Write Registration Eligibility failed: ${err.name} - ${err.message}`,
  );
};

export { logEligibilityFailure };
